import { FC } from "react";
import { Box, Typography, styled } from "@mui/material";
import { blue, button, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";

type TPartnerFlagTagProps = {
  label: string;
};

export const PartnerFlagTag: FC<TPartnerFlagTagProps> = ({ label }) => {
  return (
    <TagWrap>
      <Typography variant="cap12" color={text.primary} textAlign="center">
        {label}
      </Typography>
    </TagWrap>
  );
};

const TagWrap = styled(Box)`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  gap: 4px;
  min-width: 76px;
  height: 26px;
  white-space: nowrap;
  background: ${blue[100]};
  border: 1px solid ${button.primary};
  border-radius: ${rounded.md};
`;
